import { FetchArgs } from '@reduxjs/toolkit/query'

// Фильтр «Пән» сервис басшысы: пока выбран, ко всем запросам страниц басшы/ментора
// добавляется ?subjectId=, bff сужает по нему группы. Ставит и снимает DirectorLayout.
export const scopeSubject: { id: number | null } = { id: null }

export const withScopeSubject = (args: string | FetchArgs): string | FetchArgs => {
    if (!scopeSubject.id) return args
    const a = typeof args === 'string' ? { url: args } : args
    // свои ручки директора получают subjectId явно
    if (/^\/?director\//.test(a.url) || a.url.includes('subjectId=') || a.params?.subjectId !== undefined) return args
    return { ...a, params: { ...a.params, subjectId: scopeSubject.id } }
}
